import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { chain, SendTracking } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { BillToModel, CartModel } from "@insite/client-framework/Types/ApiModels";

export type HandlerType = Parameters<typeof SendTracking>[0];

interface TransactionData {
    event: string;
    ecommerce: {
        currency: string;
        value: number;
        transaction_id: string;
        customer: string | undefined;
        shipping: number;
        tax: number;
        items: { item_name: string; item_id: string; price?: number; quantity: number }[];
    };
}

addToChainAfter(chain, SendTracking, SendPurchaseTracking);

function SendPurchaseTracking(props: HandlerType) {
    // console.log(props.apiParameter);
    // console.log(props.apiResult);
    // console.log(props.cartToUpdate);

    const billToState = getBillToState(props.getState(), props.cartToUpdate.billToId);
    // console.log(billToState);

    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const cart = props.cartToUpdate;
    if (!cart) {
        return;
    }

    let customerNumber = props.apiResult.billTo?.customerNumber;
    if (!customerNumber) {
        const billToState = getBillToState(props.getState(), cart.billToId);
        customerNumber = billToState.value?.customerNumber;
    }

    const data: TransactionData = {
        event: "purchase",
        ecommerce: {
            currency: getCurrency(cart.currencySymbol),
            value: cart.orderGrandTotal,
            transaction_id: cart.trackId,
            shipping: cart.shippingAndHandling,
            tax: cart.totalTax,
            customer: customerNumber,
            items: [],
        },
    };

    cart.cartLines?.forEach(cartLine => {
        data.ecommerce.items.push({
            item_id: cartLine.erpNumber,
            item_name: cartLine.shortDescription,
            price: cartLine.pricing?.unitNetPrice,
            quantity: cartLine.qtyOrdered ?? 0,
        });
    });

    dataLayer.push(data);
}

function getDataLayer() {
    return (window as any).dataLayer;
}

function getCurrency(priceString: string | undefined) {
    if (priceString?.includes("$")) {
        return "USD";
    }
    return "EUR";
}
